import "../styles/admin.scss";
import "../styles/application.scss";
import ReactOnRails from "react-on-rails";

import PublicApp from "../components/PublicApp";

ReactOnRails.register({ App: PublicApp });
